import api from "../utils/axiosInstance.js";
import Swal from "sweetalert2";

export class Http {
  async post(url, data) {
    return Promise.race([
      api.post(url, data),
      new Promise((_, reject) =>
        setTimeout(() => reject(new Error("Request timeout")), 60000)
      ),
    ])
      .then((response) => {
        if (response && response.status === 200) {
          return response;
        }
      })
      .catch((error) => {
        if (error.message === "Request timeout") {
          Swal.fire({
            title: "Opps",
            text: "Something Wrong",
            icon: "error",
            confirmButtonText: "Refresh",
          }).then(() => {
            window.location.reload();
          });
        }
      });
  }
}
